/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingIdRemarkRuleFormData
 */
export interface BookingIdRemarkRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormData
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleFormData
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormData
     */
    bookingIdRemark?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingIdRemarkRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingIdRemarkRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BookingIdRemarkRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof BookingIdRemarkRuleFormData
     */
    providers?: Array<GuidIdAndLabel> | null;
}

export function BookingIdRemarkRuleFormDataFromJSON(json: any): BookingIdRemarkRuleFormData {
    return BookingIdRemarkRuleFormDataFromJSONTyped(json, false);
}

export function BookingIdRemarkRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingIdRemarkRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : json['bookingIdRemark'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function BookingIdRemarkRuleFormDataToJSON(value?: BookingIdRemarkRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
        'allowEdit': value.allowEdit,
        'bookingIdRemark': value.bookingIdRemark,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'comment': value.comment,
        'description': value.description,
        'disabled': value.disabled,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


